import React, { createElement, useEffect, useState } from 'react';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { CreationStep } from '../CreationStep';
import { FinishStep } from '../FinishStep';
import { EditStep } from '../EditStep';
import { LoadingStep } from '../LoadingStep';
import { ErrorStep } from '../ErrorStep';
import { DisambiguationStep } from '../DisambiguationStep';
import { ComingSoonStep } from '../ComingSoonStep';
import { RephraseStep } from '../RephraseStep';
import { ProMigrationStep } from '../ProMigrationStep';
import { Step } from '../../constants';
import { briefCreationDrawerIsShown } from '../../monitoring';

const stepToComponent = {
  [Step.Creation]: CreationStep,
  [Step.Loading]: LoadingStep,
  [Step.Disambiguation]: DisambiguationStep,
  [Step.Edit]: EditStep,
  [Step.Finish]: FinishStep,
  [Step.Error]: ErrorStep,
  [Step.Rephrase]: RephraseStep,
  [Step.ComingSoon]: ComingSoonStep,
  [Step.ProMigration]: ProMigrationStep,
};

export const BriefCreation: React.FC = () => {
  const { currentStep, contextId, regenerateContextId, variant, source, isOpen } = useBriefCreationContext();
  const [localContextId, setLocalContextId] = useState<string | null>(null);

  useEffect(() => {
    if (contextId) {
      setLocalContextId(contextId);
    } else if (!localContextId) {
      // request new context ID if it doesn't exist on start
      const id = regenerateContextId();
      setLocalContextId(id);
    }
  }, [contextId, localContextId, regenerateContextId]);

  useEffect(() => {
    const isBriefCreationOpen = variant === 'onboarding_routing' || isOpen;

    if (isBriefCreationOpen && currentStep !== Step.Loading && localContextId) {
      briefCreationDrawerIsShown(currentStep, localContextId, source || '', variant);
    }
  }, [currentStep, localContextId, variant, source, isOpen]);

  return createElement(stepToComponent[currentStep]);
};

export default BriefCreation;
